import { E_Format_Unit } from "./constants/Enums_FormatUtils";

export const M_Format_DateTime_OptionsDefaults = {
	year: "numeric",
	month: "numeric",
	day: "numeric",
	hour: "numeric",
	minute: "numeric",
}

export const M_Format_Units_ShortToLong = {
	"%": E_Format_Unit.PERCENT,
};
